<template>
  <!-- Toast notificaion -->
  <transition
    enter-active-class="transition ease-out duration-150 transform"
    enter-class="opacity-0 translate-y-10"
    enter-to-class="opacity-100"
    leave-active-class="transition ease-in duration-150 transform"
    leave-class="opacity-100"
    leave-to-class="opacity-0 translate-y-10"
  >
    <div
      id="toast"
      v-if="toastData.visible"
      class="fixed w-11/12 m-auto mb-8 z-20 bottom-0 inset-x-0 cursor-pointer rounded-md shadow-lg lg:mb-10 xl:w-9/12 xxl:w-8/12"
    >
      <!-- Contetnt -->
      <div
        id="toast-content"
        class="flex flex-col w-full px-4 pt-3 pb-6 sm:px-6 sm:pt-4 sm:pb-8 lg:pb-6 lg:flex-row lg:items-center"
      >
        <div class="pb-2 lg:w-4/12 lg:pl-2 lg:pb-0">
          <div class="text-xl sm:text-2xl">
            {{ toastData.word }}
          </div>
          <div class="">
            {{ toastData.pronunciation }}
          </div>
        </div>
        <div class="italic pb-2 lg:w-3/12">
          {{ toastData.type }}
        </div>
        <div class="lg:w-5/12">
          {{ toastData.definition }}
        </div>
      </div>
      <!-- 5 second progress bar -->
      <div class="toast-bar progress"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      hidingToast: false,
      toastData: {
        visible: false,
        word: 'Word',
        pronunciation: 'Pronunciation',
        type: 'Noun',
        definition: 'Definition'
      }
    }
  },
  methods: {
    // Call with Toast([]) with these props:
    //"[Name]","[Pronunciation]",
    //"[Type (verb, adj, pronoun, etc.)]",
    //"[Definition]")
    showToast: function(word, pronunciation, type, definition) {
      let toast = this
      // Set new toast data
      // Setting visible to true shows it
      toast.toastData = {
        visible: true,
        word: word,
        pronunciation: pronunciation,
        type: type,
        definition: definition
      }
      // Hide after 8 seconds
      setTimeout(function() {
        toast.hideToast()
      }, 8000)
    },
    // Hide toast,
    hideToast: function() {
      let toast = this
      // Hiding toast
      toast.hidingToast = true
      // 300ms delay for animation out
      setTimeout(function() {
        toast.hidingToast = false
        toast.toastData.visible = false
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/scss/variables/breakpoints.scss';
@import '~@/styles/scss/variables/themes.scss';
@import '~@/styles/scss/variables/typography.scss';

#toast {
  @include fontDefinition;
}
// Progress bar that shows when toast will be dismissed
.toast-bar {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 6px;
  // Bar that shows progress
  &:after {
    content: ' ';
    display: flex;
    width: 0%;
    height: 100%;
    border-bottom-left-radius: 4px;
    background-color: $white;
  }
  // Show progress moving when class is added with v-if
  &.progress:after {
    animation: toastBar 8s 1 0s linear;
  }
  @include breakpoint(lg) {
    display: none;
  }
}
// Animation
// Makes bar under toast go from left to right
// 100% width to 0% in 8 seconds.
@keyframes toastBar {
  0% {
    width: 0%;
  }
  1% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
</style>
